import { render, staticRenderFns } from "./bold-header.vue?vue&type=template&id=93643106&scoped=true"
import script from "./bold-header.vue?vue&type=script&lang=js"
export * from "./bold-header.vue?vue&type=script&lang=js"
import style0 from "./bold-header.vue?vue&type=style&index=0&id=93643106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93643106",
  null
  
)

export default component.exports